import apiWorker from '../apiWorker'

const mx_initial_connections = {
    create : (data) => apiWorker('post', `/v1/api/mx_initial_connections/${data.member_guid}/${data.contact_id}/${data.company_id}/${data.access_code}`, data, true),
}

export default mx_initial_connections;